import React from 'react';

import './LearnMoreAboutUs.css';

export const LearnMoreAboutUs = () => {
  return (
    <div className="container">
      <h3 className="title">ABOUT RIDENOW & RIDENOW AUCTIONS</h3>

      <p className="detail-container">
        RideNow, a RumbleOn company, is the largest dealership group in the
        country with more than 60 retail locations across the United States. As
        we expand with RideNow auctions, our Orlando location is becoming ground
        zero for this never-before-seen auction event. Since 1983, we have been
        leading the community to bring quality vehicles, expert service, and
        innovative ideas to adventurers everywhere. Now, we are proud to expand
        to the world of auctions and give retail riders a chance to buy at
        dealer prices, through RideNow Orlando.
      </p>
    </div>
  );
};
